import { XInput, XCheckbox, DatePicker, CaseFileUpload, CasePlaintiff, CaseDefendant } from '../../../../components';
import Constants from '../../../../Constants';
import XSelect from '../../../../components/common/XSelect';
import { handleEnterKeyPress } from "../../../../utils/handleEnterKey";
import ImportPartnerSec from "./ImportPartnerSec";
import useCaseTypeOptions from '../../../../hooks/useCaseTypeOptions';
import useCaseInfo from '../../../../hooks/useCaseInfo';
import { FORCE_RESET_TOGGLE_DISPLAY } from '../../../../constants/UIStrings';
import XButton from '../../../../components/common/XButton';
import { formBackgroundClasses, formItemPdClasses } from '../../../../components/common/formClasses';
import { TOUR_TARGETS } from '../../../../constants/tourTargets';
import TeamsSelector from '../../../../components/ui-control/TeamsSelector';

const wrapperClasses = 'p-0!';

const accordionClasses = `accordion ${formBackgroundClasses} ${formItemPdClasses} pb-6!`;

const headerRowClasses = 'flex justify-between items-center w-full mr-4 mb-4';

const importWrapperClasses = 'relative items-center';

const halfWidthGroupClasses = 'form-group w-1/2!';

const fileUploadColClasses = 'col-md-12 mb-6!';

// Sand hairline separating the case fields from the party columns.
const partyGridClasses =
    'grid grid-cols-12 gap-4 pt-8 mt-4 border-t border-border-accent';

const CaseInfoForm = () => {
    const caseTypeOptions = useCaseTypeOptions();
    const {
        formik,
        getFieldProps,
        showIntegratorList,
        setShowIntegratorList,
        isDelayedPayment,
        isLoading,
        isShowForceReset,
        caseInfoFileUpload,
        caseInfoRemoveFile,
    } = useCaseInfo();

    if (!formik?.values?.caseInfo) {
        return null;
    }

    return (
        <form onKeyDown={(e) => handleEnterKeyPress(e)}>
            <div className={wrapperClasses}>
                <div className={accordionClasses}>
                    <div className={headerRowClasses}>
                        <h2>Case Information</h2>
                        <div className={importWrapperClasses} data-tour={TOUR_TARGETS.IMPORT_PARTNER}>
                            {!showIntegratorList && (
                                <XButton
                                    variant="outlinePrimary"
                                    onClick={() => setShowIntegratorList(true)}
                                >
                                    Import Case from Partner
                                </XButton>
                            )}
                            <ImportPartnerSec showIntegratorList={showIntegratorList} setShowIntegratorList={setShowIntegratorList} />
                        </div>
                    </div>
                    <div className="row items-end" data-tour={TOUR_TARGETS.CASE_BASICS}>
                        <div className="col-md-12">
                            <div className={halfWidthGroupClasses}>
                                <XInput
                                    label="Case Name"
                                    placeholder="Plaintiff vs Defendant"
                                    {...getFieldProps('caseInfo.caseName')}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className={halfWidthGroupClasses}>
                                <XSelect
                                    emptyOption={false}
                                    label="Case Type"
                                    options={caseTypeOptions}
                                    {...getFieldProps('caseInfo.caseType', { useDebounce: false })}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className={halfWidthGroupClasses}>
                                <TeamsSelector/>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="row items-end">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <DatePicker
                                            label="Date of incident"
                                            {...getFieldProps('caseInfo.dateOfIncident', { useDebounce: false })}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-3 pr-0!">
                                    <div className="form-group">
                                        <XSelect
                                            emptyOption={false}
                                            label="State where incident occurred"
                                            options={Constants.Dropdowns.States}
                                            {...getFieldProps('caseInfo.stateOfIncident', { useDebounce: false })}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="row items-end">
                                <div className="col-md-6">
                                    <XCheckbox
                                        className="mb-6"
                                        label="Attach Uploaded Docs as Exhibits to the Demand Letter"
                                        {...getFieldProps('caseInfo.isIncludeExhibit', { type: 'checkbox', useDebounce: false })}
                                        infoText={formik.values.caseInfo.isIncludeExhibit && "PDFs over 150 pages will not be included as exhibits"}
                                    />
                                    {(isShowForceReset) && (
                                        <XCheckbox
                                            className="mb-6"
                                            label={FORCE_RESET_TOGGLE_DISPLAY}
                                            {...getFieldProps('caseInfo.isForceReset', { type: 'checkbox', useDebounce: false })}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        {isDelayedPayment && (
                            <div className={fileUploadColClasses}>
                                <CaseFileUpload
                                    label='Letter of Protection'
                                    onFileSelect={(files) => caseInfoFileUpload("letterOfProtection", files)}
                                    files={formik.values?.caseInfo?.letterOfProtection?.s3UrlPath ? [formik.values.caseInfo.letterOfProtection] : []}
                                    onRemove={(file) => caseInfoRemoveFile("letterOfProtection", file)}
                                    isLoading={isLoading}
                                />
                            </div>
                        )}
                    </div>
                    <div className={partyGridClasses}>
                        <CasePlaintiff />
                        <CaseDefendant />
                    </div>
                </div>
            </div>
        </form>
    );
};

export default CaseInfoForm;
